import { useWindowSize } from "@housebets/housebets-x-package";
import { useLayoutContext } from "@housebets/housebets-x-package/lib/components/layout/Layout";
import {useAppSelector} from "hooks/useAppSelector";

export const useProfileToolbarData = () => {
    const isAuth = useAppSelector((state) => state.user.isLogin);
    const {
        isRightMenuOpen,
        setIsRightMenuOpen,
    } = useLayoutContext();
    const { windowSize, isMobile, isTablet } = useWindowSize();

    return {
        isAuth,
        isRightMenuOpen,
        setIsRightMenuOpen,
        windowSize,
        isMobile,
        isTablet
    }
}